import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'
import ConfirmGroupConsultation from './pages/ConfirmGroupConsultation'
import ReservationConsultations from './pages/ReservationsConsultations'
import ReservationConfirmation from './pages/ReservationConfirmation'

const Consultations = lazy(
  () => import('@/modules/MyCalls/pages/Consultations'),
)
const ConsultationDetails = lazy(
  () => import('@/modules/MyCalls/pages/ConsultationDetails'),
)
const ConsultationDetailsPv = lazy(
  () => import('@/modules/MyCalls/pages/ConsultationDetailsPv'),
)
const ConsultationWithoutPreferenceDetails = lazy(
  () => import('@/modules/MyCalls/pages/ConsultationWithoutPreferenceDetails'),
)
const ConsultationDetailsGroup = lazy(
  () => import('@/modules/MyCalls/pages/ConsultationDetailsGroup'),
)

const MyCalllsRoutes = [
  <RequireAuthentication
    path="/meus-atendimentos"
    key="/meus-atendimentos"
    exact
    component={Consultations}
  />,
  <RequireAuthentication
    path="/minhas-reservas/reservas"
    key="/minhas-reservas/reservas"
    exact
    component={ReservationConsultations}
  />,
  <RequireAuthentication
    path="/minhas-reservas/confirmar-reserva"
    key="/minhas-reservas/confirmar-reserva"
    exact
    component={ReservationConfirmation}
  />,
  <RequireAuthentication
    path="/minhas-reservas/confirmar-reserva/:id"
    key="/minhas-reservas/confirmar-reserva/:id"
    exact
    component={ReservationConfirmation}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/:id"
    key="/meus-atendimentos/atendimento/:id"
    exact
    component={ConsultationDetails}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/prefila/:preQueueId"
    key="/meus-atendimentos/atendimento/prefila/:preQueueId"
    exact
    component={ConsultationWithoutPreferenceDetails}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/psicologiaviva/:id"
    key="/meus-atendimentos/atendimento/psicologiaviva/:id"
    exact
    component={ConsultationDetailsPv}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/grupo/confirmado"
    key="/meus-atendimentos/atendimento/grupo/confirmado"
    exact
    component={ConfirmGroupConsultation}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/grupo/:id"
    key="/meus-atendimentos/atendimento/grupo/:id"
    exact
    component={ConsultationDetailsGroup}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/:id/:action"
    key="/meus-atendimentos/atendimento/:id/:action"
    exact
    component={ConsultationDetails}
  />,
  <RequireAuthentication
    path="/meus-atendimentos/atendimento/prefila/:preQueueId/:action"
    key="/meus-atendimentos/atendimento/prefila/:preQueueId/:action"
    exact
    component={ConsultationWithoutPreferenceDetails}
  />,
]

export default MyCalllsRoutes
